import { Disclaimer, ToolsConfiguration } from '@3ddv/ngx-sites-builder-lib';
import { Component, ViewChild } from '@angular/core';
import { Subscription, take, takeUntil } from 'rxjs';
import { Sidebar } from '../../sb-editor-sidebar/models/sidebar.model';
import { ToolsService } from '../services/tools.service';
import { SblibService } from '../../services/sblib.service';
import { SidebarService } from '../../sb-editor-sidebar/services/sidebar.service';
import { ToastrService } from 'ngx-toastr';
import { DisclaimerGeneratorComponent } from './disclaimer-generator/disclaimer-generator.component';
import { DisclaimerService } from './services/disclaimer.service';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss'],
})
export class DisclaimerComponent {
  private subscriptions: Array<Subscription> = [];
  public tool: Disclaimer;
  public itemList: Array<any>;
  @ViewChild('disclaimergeneration', { static: false }) disclaimergenerationComponent: DisclaimerGeneratorComponent;

  public tabs = { active: 'disclaimergeneration' };
  public sidebar: Sidebar = null;
  constructor(
    private toolsService: ToolsService,
    private disclaimerService: DisclaimerService,
    private sblibService: SblibService,
    private sidebarService: SidebarService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      console.log(res);
      if (res.disclaimer) {
        this.tool = JSON.parse(JSON.stringify(res.disclaimer));
      } else {
        console.error('disclaimer tool not found');
        return;
      }
    });
    this.subscriptions.push(tools$);

    const sidebarasync$ = this.sidebarService.getAsyncSidebar$().subscribe(res => {
      this.sidebar = res;
    });
    this.subscriptions.push(sidebarasync$);

    const sidebar$ = this.sidebarService.getSidebar$().subscribe(res => {
      this.sidebar = res;
    });
    this.subscriptions.push(sidebar$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }

  public save() {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res => {
      res.disclaimer.enabled = this.tool.enabled;
      res.disclaimer.colorText = this.tool.colorText;
      res.disclaimer.colorBg = this.tool.colorBg;
      res.disclaimer.data = this.tool.data;
      this.tool = Object.assign({}, res.disclaimer);
      this.sblibService.apply(res);
      this.toastrService.success('', 'Success');
    });
    this.subscriptions.push(tools$);
  }

  public finishedUpload($event) {
    console.log($event);
  }
}
